import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PlansService } from '@service/plans.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '@service/auth.service'

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  cardInfoForm: FormGroup;
  userId: number;
  public selectedData: { price: string, priceInt: number, description: string }

  constructor(
    private formBuilder: FormBuilder,
    private plansService: PlansService,
    private toastr: ToastrService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.selectedData = JSON.parse(localStorage.getItem("selectedPlan"));
    this.userId = this.authService.user.id;
    this.cardInfoForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      number: ['', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]],
      month: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(2)]],
      year: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      cvv: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(3)]]
    });
  }

  onSubmit(): void {
    this.plansService.creditRequest({
      description: this.selectedData.description,
      value: this.selectedData.priceInt,
      card: this.cardInfoForm.value,
      user_id: this.userId
    }).subscribe({
      next: () => {
        this.toastr.success(
          "Seu pagamento foi confirmado, talvez seja preciso recarregar a página para perceber as alterações"
        );
      },
      error: () => {
        this.toastr.error(
          "Não foi possível realizar o pagamento, confira as informações do cartão de crédito e tente novamente"
        );
      }
    });
  }

}
